import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from "../../_services";
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from "rxjs";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  userExists;
  user;    
  
  subscription: Subscription

  constructor(private auth : AuthenticationService,   private router: Router) { 
    this.userExists = auth.isAuth();
    this.user = auth.currentUserValue;             
    this.subscription = auth.currentUser.subscribe(message=>{       
      this.user = auth.currentUserValue;       
      this.userExists = auth.isAuth();           
    });
  }

  ngOnInit() {
  }

  hideSidebar(e) {
    e.preventDefault();
    $("#sidebar-wrapper").removeClass("sidebar-toggled");
  }

}
